import React from "react";
import { CarouselModal } from "@src/lms/jelly/extensions/layouts/_lesson/case7/common/components/CarouselModal";
import { useIntl } from "react-intl";

import styles from "./BioModal.module.scss";
import { messages } from "../about-the-artist/AboutTheArtist.messages";
import { useUi } from "@jelly/lesson";

type GerrietBioModalProps = Omit<React.ComponentProps<typeof CarouselModal>, "children">;
export const GerrietBioModal: React.FC<GerrietBioModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();

  let linkToPresent = "placeholder-link";
  try {
    const url = new URL(formatMessage(messages.bioGerrietLink));
    linkToPresent = url.host;
  } catch {
    // ...
  }

  return (
    <ui.Modal {...props} title={formatMessage(messages.bioGerrietTitle)}>
      <div className={styles.slide}>
        <div className={styles.content}>{formatMessage(messages.bioGerrietDescription)}</div>
        <div className={styles.link}>
          <ui.Button
            size="small"
            shape={"normal"}
            theme={"primary"}
            onClick={() => window.open(formatMessage(messages.bioGerrietLink))}
          >
            {linkToPresent}
          </ui.Button>
        </div>
      </div>
    </ui.Modal>
  );
};
